import Phaser from "phaser";

export default class Blank extends Phaser.Scene {
    constructor() {
        super({key: 'BlankScene'})
        console.log('Blank Scene constructor!')
        window.startGameScene = () => this.scene.start('GameScene', {level: window.gameStartConfig.selectedLevel*1, score: 0})
    }
}